import React from 'react';
import {
  CategoriesRoute, DailyNewsRoute, MaterialsRoute,
} from 'app/constants/Routes';
import { LanguageId } from 'app/constants/enums/Language/data';
import { useBrand } from '../OrganizationContext';
import { useBookingState } from 'app/containers/rtc/BookingContext/BookingState';
import { BookingType } from 'app/models/rtc/booking/constants';

interface IRenderPropValue {
  materialsUrl: string | null;
  dailyNewsUrl: string | null;
}

interface IChildrenProp {
  children: (value: IRenderPropValue) => React.ReactNode;
  languageId?: LanguageId;
}

interface IProps extends IChildrenProp {
  showMaterials: boolean;
  showDailyNews: boolean;
}

const BrandMaterialsLink: React.FC<IProps> = ({
  showDailyNews,
  showMaterials,
  languageId,
  children,
}) => {
  const materialsUrl = showMaterials ? (
    languageId ? CategoriesRoute.getPathname({ languageId }) : MaterialsRoute.getPathname()
  ) : null;
  return (
    <>
      {children({
        materialsUrl,
        dailyNewsUrl: showDailyNews ? DailyNewsRoute.getPathname() : null,
      })}
    </>
  );
};

export default (props: IChildrenProp) => {
  const brand = useBrand();
  const bookingState = useBookingState();
  const showDailyNews = bookingState?.bookingType !== BookingType.TestCall &&
    brand.siteFeatures.dailyNews.enabled;
  const showMaterials = bookingState?.bookingType !== BookingType.TestCall &&
    brand.siteFeatures.materials.enabled;
  return (
    <BrandMaterialsLink {...props} showDailyNews={showDailyNews} showMaterials={showMaterials} />
  );
};
